<template>
  <section>
    <div>
      <h3>
        Emissionen
        <Popper placement="bottom" offset-distance="5" arrow="true" class="popover">
          <template #content><span v-html="store.popupEmiss"></span></template>
          <button class="info" type="button"></button>
        </Popper>
      </h3>
      <button class="toggle" v-on:click="toggleFunction"></button>
    </div>
    <EmissGoal></EmissGoal>
    <div class="toggled" ref="toggleElement">
      <EmissTons :dataEmissTons="dataEmissTons"></EmissTons>
      <EmissSaving :dataEmissSaving="dataEmissSaving"></EmissSaving>
    </div>
  </section>
</template>

<script>
import { store } from "../store";
import EmissGoal from "./emissGoal.vue";
import EmissSaving from "./emissSaving.vue";
import EmissTons from "./emissTons.vue";
import Popper from "vue3-popper";

export default {
  components: {
    EmissGoal,
    EmissSaving,
    EmissTons,
    Popper,
  },
  data() {
    return {
      store,
      dataEmissSaving: [],
      dataEmissTons: [],
    };
  },
  methods: {
    toggleFunction() {
      this.$emit("child-event");
    },
  },
  mounted() {
    fetch(store.urlEmiss)
      .then((response) => response.json())
      .then((data) => {
        //this.posts = data
        //console.log("data Emiss:", data);
        store.dataEmissGoal = data.bigNumber_CO2;

        this.dataEmissSaving = data.sektorziele;
        this.dataEmissPerson = data.CO2_pro_Kopf;
        this.dataEmissTons = [data.CO2_aktuell, data.CO2_last_year];
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
